/* istanbul ignore file */
import rootSaga from "../sagas";
import configureStore from "./CreateStore";
import reducers from "./Reducer";

const idx = (state = null) => {
	const storeConfig = configureStore(reducers, rootSaga, state);
	const { store, sagaMiddleware } = storeConfig;
	let { sagasManager } = storeConfig;

	const hot = import.meta.hot;
	if (hot) {
		hot.accept("./Reducer", newModule => {
			const nextRootReducer = newModule.default;
			store.replaceReducer(nextRootReducer);
		});

		hot.accept("../sagas", newModule => {
			const newYieldedSagas = newModule.default;
			sagasManager.cancel();
			sagasManager.toPromise().then(() => {
				sagasManager = sagaMiddleware.run(newYieldedSagas);
			});
		});
	}

	return store;
};

export default idx;
